import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api";
import LoginPage from "./LoginPage";

export default function InvitePage() {
  const { token } = useParams();
  const [invite, setInvite] = useState(null);

  useEffect(() => {
    api.get(`/invites/${token}`).then(({ data }) => setInvite(data)).catch(() => setInvite({ valid: false }));
  }, [token]);

  if (invite === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <p className="font-display text-3xl text-[#FF3B30] animate-pulse">GYMTRACK</p>
      </div>
    );
  }
  if (!invite.valid) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0A] px-6 text-center">
        <h1 className="font-display text-5xl text-white">INVITATION INVALIDE</h1>
        <p className="text-[#B0B0B4] text-sm mt-2">Ce lien a déjà été utilisé ou n'existe pas.</p>
        <Link to="/" data-testid="invite-back-link" className="mt-6 text-[#FF3B30] underline underline-offset-4 text-sm">Retour à la connexion</Link>
      </div>
    );
  }
  return <LoginPage inviteToken={token} inviteEmail={invite.email || ""} />;
}
